/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { CopyServerSideWorkflowRequestDto } from '../models/copy-server-side-workflow-request-dto';
import { CreateWorkflowProcessRequestDto } from '../models/create-workflow-process-request-dto';
import { CreateWorkflowProcessRequestDtoWithRelations } from '../models/create-workflow-process-request-dto-with-relations';
import { CreateWorkflowProcessResponseDto } from '../models/create-workflow-process-response-dto';
import { CreateWorkflowWithCustomFunctionDefinitionRequestDto } from '../models/create-workflow-with-custom-function-definition-request-dto';
import { DeleteWorkflowEventRequestDto } from '../models/delete-workflow-event-request-dto';
import { EntryPointsWorkflowResponseDto } from '../models/entry-points-workflow-response-dto';
import { GenerateWorkflowFunctionDefinitionResponseDto } from '../models/generate-workflow-function-definition-response-dto';
import { OpenAiWorkflowFunctionDefinitionRequestDto } from '../models/open-ai-workflow-function-definition-request-dto';
import { OpenAiWorkflowProcessRequestDto } from '../models/open-ai-workflow-process-request-dto';
import { WorkflowProcessAnalyzeResponseDto } from '../models/workflow-process-analyze-response-dto';

@Injectable({
  providedIn: 'root',
})
export class WorkflowControllerService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation workflowControllerDeleteWorkflowByWorkflowEventId
   */
  static readonly WorkflowControllerDeleteWorkflowByWorkflowEventIdPath = '/workflow';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteWorkflowByWorkflowEventId()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  deleteWorkflowByWorkflowEventId$Response(params?: {
    body?: DeleteWorkflowEventRequestDto
  }): Observable<StrictHttpResponse<any>> {

    const rb = new RequestBuilder(this.rootUrl, WorkflowControllerService.WorkflowControllerDeleteWorkflowByWorkflowEventIdPath, 'delete');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<any>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `deleteWorkflowByWorkflowEventId$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  deleteWorkflowByWorkflowEventId(params?: {
    body?: DeleteWorkflowEventRequestDto
  }): Observable<any> {

    return this.deleteWorkflowByWorkflowEventId$Response(params).pipe(
      map((r: StrictHttpResponse<any>) => r.body as any)
    );
  }

  /**
   * Path part for operation workflowControllerCopyServerSideWorkflow
   */
  static readonly WorkflowControllerCopyServerSideWorkflowPath = '/workflows/copy-server-side-workflow';

  /**
   * Copy models associated with the workflow event model.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `copyServerSideWorkflow()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  copyServerSideWorkflow$Response(params?: {
    body?: CopyServerSideWorkflowRequestDto
  }): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, WorkflowControllerService.WorkflowControllerCopyServerSideWorkflowPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Copy models associated with the workflow event model.
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `copyServerSideWorkflow$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  copyServerSideWorkflow(params?: {
    body?: CopyServerSideWorkflowRequestDto
  }): Observable<void> {

    return this.copyServerSideWorkflow$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation workflowControllerCreateProcess
   */
  static readonly WorkflowControllerCreateProcessPath = '/workflows/create-process';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createProcess()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createProcess$Response(params?: {
    body?: Array<CreateWorkflowProcessRequestDto>
  }): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, WorkflowControllerService.WorkflowControllerCreateProcessPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `createProcess$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createProcess(params?: {
    body?: Array<CreateWorkflowProcessRequestDto>
  }): Observable<void> {

    return this.createProcess$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation workflowControllerCreateWorkflowWithCustomFunctionDefinition
   */
  static readonly WorkflowControllerCreateWorkflowWithCustomFunctionDefinitionPath = '/workflows/create-workflow-with-custom-function-definition';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createWorkflowWithCustomFunctionDefinition()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createWorkflowWithCustomFunctionDefinition$Response(params?: {
    body?: CreateWorkflowWithCustomFunctionDefinitionRequestDto
  }): Observable<StrictHttpResponse<CreateWorkflowProcessResponseDto>> {

    const rb = new RequestBuilder(this.rootUrl, WorkflowControllerService.WorkflowControllerCreateWorkflowWithCustomFunctionDefinitionPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<CreateWorkflowProcessResponseDto>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `createWorkflowWithCustomFunctionDefinition$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createWorkflowWithCustomFunctionDefinition(params?: {
    body?: CreateWorkflowWithCustomFunctionDefinitionRequestDto
  }): Observable<CreateWorkflowProcessResponseDto> {

    return this.createWorkflowWithCustomFunctionDefinition$Response(params).pipe(
      map((r: StrictHttpResponse<CreateWorkflowProcessResponseDto>) => r.body as CreateWorkflowProcessResponseDto)
    );
  }

  /**
   * Path part for operation workflowControllerFindEntryPoints
   */
  static readonly WorkflowControllerFindEntryPointsPath = '/workflows/entry-points';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `findEntryPoints()` instead.
   *
   * This method doesn't expect any request body.
   */
  findEntryPoints$Response(params?: {
  }): Observable<StrictHttpResponse<EntryPointsWorkflowResponseDto>> {

    const rb = new RequestBuilder(this.rootUrl, WorkflowControllerService.WorkflowControllerFindEntryPointsPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<EntryPointsWorkflowResponseDto>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `findEntryPoints$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  findEntryPoints(params?: {
  }): Observable<EntryPointsWorkflowResponseDto> {

    return this.findEntryPoints$Response(params).pipe(
      map((r: StrictHttpResponse<EntryPointsWorkflowResponseDto>) => r.body as EntryPointsWorkflowResponseDto)
    );
  }

  /**
   * Path part for operation workflowControllerGenerateByAi
   */
  static readonly WorkflowControllerGenerateByAiPath = '/workflows/generate-function-definition-by-ai';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `generateByAI()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  generateByAI$Response(params?: {
    body?: OpenAiWorkflowFunctionDefinitionRequestDto
  }): Observable<StrictHttpResponse<GenerateWorkflowFunctionDefinitionResponseDto>> {

    const rb = new RequestBuilder(this.rootUrl, WorkflowControllerService.WorkflowControllerGenerateByAiPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<GenerateWorkflowFunctionDefinitionResponseDto>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `generateByAI$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  generateByAI(params?: {
    body?: OpenAiWorkflowFunctionDefinitionRequestDto
  }): Observable<GenerateWorkflowFunctionDefinitionResponseDto> {

    return this.generateByAI$Response(params).pipe(
      map((r: StrictHttpResponse<GenerateWorkflowFunctionDefinitionResponseDto>) => r.body as GenerateWorkflowFunctionDefinitionResponseDto)
    );
  }

  /**
   * Path part for operation workflowControllerGenerateWorkflowProcessByAi
   */
  static readonly WorkflowControllerGenerateWorkflowProcessByAiPath = '/workflows/generate-workflow-process-by-ai';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `generateWorkflowProcessByAI()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  generateWorkflowProcessByAI$Response(params?: {
    endpointEnable?: boolean;
    options?: any;
    body?: OpenAiWorkflowProcessRequestDto
  }): Observable<StrictHttpResponse<Array<CreateWorkflowProcessRequestDtoWithRelations>>> {

    const rb = new RequestBuilder(this.rootUrl, WorkflowControllerService.WorkflowControllerGenerateWorkflowProcessByAiPath, 'post');
    if (params) {
      rb.query('endpointEnable', params.endpointEnable, {});
      rb.query('options', params.options, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<CreateWorkflowProcessRequestDtoWithRelations>>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `generateWorkflowProcessByAI$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  generateWorkflowProcessByAI(params?: {
    endpointEnable?: boolean;
    options?: any;
    body?: OpenAiWorkflowProcessRequestDto
  }): Observable<Array<CreateWorkflowProcessRequestDtoWithRelations>> {

    return this.generateWorkflowProcessByAI$Response(params).pipe(
      map((r: StrictHttpResponse<Array<CreateWorkflowProcessRequestDtoWithRelations>>) => r.body as Array<CreateWorkflowProcessRequestDtoWithRelations>)
    );
  }

  /**
   * Path part for operation workflowControllerErrorAnalyze
   */
  static readonly WorkflowControllerErrorAnalyzePath = '/workflows/process-analyze/{correlationId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `errorAnalyze()` instead.
   *
   * This method doesn't expect any request body.
   */
  errorAnalyze$Response(params: {
    correlationId: string;
  }): Observable<StrictHttpResponse<WorkflowProcessAnalyzeResponseDto>> {

    const rb = new RequestBuilder(this.rootUrl, WorkflowControllerService.WorkflowControllerErrorAnalyzePath, 'get');
    if (params) {
      rb.path('correlationId', params.correlationId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkflowProcessAnalyzeResponseDto>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `errorAnalyze$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  errorAnalyze(params: {
    correlationId: string;
  }): Observable<WorkflowProcessAnalyzeResponseDto> {

    return this.errorAnalyze$Response(params).pipe(
      map((r: StrictHttpResponse<WorkflowProcessAnalyzeResponseDto>) => r.body as WorkflowProcessAnalyzeResponseDto)
    );
  }

  /**
   * Path part for operation workflowControllerProcessTodoComments
   */
  static readonly WorkflowControllerProcessTodoCommentsPath = '/workflows/process-todo-comments';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `processTodoComments()` instead.
   *
   * This method doesn't expect any request body.
   */
  processTodoComments$Response(params?: {
  }): Observable<StrictHttpResponse<any>> {

    const rb = new RequestBuilder(this.rootUrl, WorkflowControllerService.WorkflowControllerProcessTodoCommentsPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<any>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `processTodoComments$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  processTodoComments(params?: {
  }): Observable<any> {

    return this.processTodoComments$Response(params).pipe(
      map((r: StrictHttpResponse<any>) => r.body as any)
    );
  }

}
